import { twMerge } from 'tailwind-merge';

const Card = ( {
    active,
    icon,
    title,
    href,
    redirectTo,
}: {
    active?: boolean;
    icon: JSX.Element;
    title: string;
    href: string;
    redirectTo: ( hashPath: string ) => void;
} ) => (
    <a
        className={ twMerge(
            'flex items-center gap-3 rounded-lg border p-3 !bg-white transition h-20 w-80 hover:border-[#7047EB] hover:shadow',
            active ? 'border-[#7047EB] shadow' : 'border-gray-200'
        ) }
        href={ `#${ href.replace( /^#/, '' ) }` }
        onClick={ ( e ) => {
            e.preventDefault();
            redirectTo( href );
        } }
    >
        <div
            className={ twMerge(
                'w-10 h-10 rounded-md flex items-center justify-center border hover:bg-[#EFEAFF] hover:text-[#7047EB] hover:border-[#CEBEFC]',
                active
                    ? 'bg-[#EFEAFF] text-[#7047EB] border-[#CEBEFC]'
                    : 'bg-[#F8F9F8] text-[#828282] border-[#E9E9E9]'
            ) }
        >
            { icon }
        </div>
        <span className="text-sm font-semibold text-[#25252D]">{ title }</span>
    </a>
);

export default Card;
